module.exports = __webpack_public_path__ + "img/gpt1.12059214.png";